import { formatDynamicTextValue } from './dynamicTextFormatHelpers';

/**
 * The canvas's three-way precedence for a merge-tag chip's displayed text,
 * matching what Preview & Test has always done (PreviewModal's
 * `replaceMergeTags`): a real value wins, a field that resolved to blank falls
 * to the user's configured fallback text, and anything else shows the field's
 * own label.
 *
 * `resolvedDisplayValue` carries the distinction the canvas used to lose, and
 * the two empties are NOT interchangeable:
 *
 * - `undefined` — this chip is not eligible for a resolved value at all: no
 *   listing bound in its scope, a key the bound listing has no notion of, or
 *   Design Manager, where the field label IS the intended display. Keeps the
 *   label, fallback text or not.
 * - `''` — eligible, looked it up, and the record's field is genuinely empty.
 *   This is the only case that earns the configured fallback.
 *
 * Callers producing that value (MjmlDomRender's `resolveMergeTagDisplayValue`)
 * must therefore return two different empties rather than collapsing both into
 * `undefined` — collapsing them is what made the canvas print "County" where
 * preview and the sent email both printed "Elko County".
 */
export function pickBadgeDisplayText(
	resolvedDisplayValue: string | undefined,
	tagFallback: string,
	label: string,
	tagFormat?: string,
	tagMaxLength?: number | null,
): string {
	if (resolvedDisplayValue) {
		return formatDynamicTextValue(resolvedDisplayValue, tagFormat, tagMaxLength);
	}
	if (resolvedDisplayValue === '' && tagFallback) {
		return tagFallback;
	}
	return label;
}
